import React from 'react';
import { Provider } from 'mobx-react';
import stores from './stores';
import Routes from './Routes';

import "./static/css/compile.scss";
import "./CustomCrosscert.scss";

class App extends React.Component {
  unisignLibrary = React.createRef();

  componentDidMount() {
    if ( !location.host.includes("localhost")&& this.unisignLibrary && !this.unisignLibrary.current ) { //배포시 사용
    // if (!location.host.includes("localhost")&&!this.unisignLibrary.current) { //로컬에러날때 사용 실행
      this.unisignLibrary.current = new createUnisign();
    }
  }

  render() {
    //MES3.0 css 제거
    //document.head.getElementsByTagName("link")[0].disabled = true;

    // localhost , test steel 일때만 console.log 보이게
    if (!(location.origin.includes("localhost")) || !(location.origin.includes("test.steel-n.com"))) {
      console.log("location::", location.origin);
      console.log = function no_console() {
      };
      console.warn = function no_console() {
      };
    }

    return (
      <div className="App">
        <Provider {...stores}>
          <Routes/>
        </Provider>
      </div>
    );
  }
}

export default App;
